module.exports = __webpack_public_path__ + "media/assets/images/event-button-5c0aec5c26d352f5e2470890d841d340.svg";